import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface OnboardingCompanion {
  id: string;
  personalInfoFirstName: string | null;
  personalInfoLastName: string | null;
  personalInfoPhone: string | null;
}

export function toOnboardingCompanion(c: {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
}): OnboardingCompanion {
  return {
    id: c.id,
    personalInfoFirstName: c.firstName ?? null,
    personalInfoLastName: c.lastName ?? null,
    personalInfoPhone: c.phone ?? null,
  };
}

// needs to be mapped
interface ServiceProviderData {
  serviceProviderType: string;
}

interface ServiceProviderOnboardingState {
  serviceProviderId: string | null;
  providerTypeId: string | null;
  ownerInfoSubmitted: boolean;
  companions: OnboardingCompanion[] | null;
  selectedCompanion: OnboardingCompanion | null;
  setServiceProviderId: (id: string | null) => void;
  setProviderTypeId: (id: string | null) => void;
  setOwnerInfoSubmitted: (submitted: boolean) => void;
  setCompanions: (companions: OnboardingCompanion[] | null) => void;
  setSelectedCompanion: (companion: OnboardingCompanion | null) => void;
  reset: () => void;
  clearServiceProviderId: () => void;
  serviceProvider: ServiceProviderData;
  setServiceProvider: (data: Partial<ServiceProviderData>) => void;
}

export const useServiceProviderOnboardingStore = create<ServiceProviderOnboardingState>()(
  persist(
    (set) => ({
      serviceProviderId: null,
      providerTypeId: null,
      ownerInfoSubmitted: false,
      companions: [],
      selectedCompanion: null,
      setServiceProviderId: (id) => set({ serviceProviderId: id }),
      setProviderTypeId: (id) => set({ providerTypeId: id }),
      setOwnerInfoSubmitted: (submitted) => set({ ownerInfoSubmitted: submitted }),
      setCompanions: (companions) => set({ companions }),
      setSelectedCompanion: (companion) => set({ selectedCompanion: companion }),
      reset: () =>
        set({
          serviceProviderId: null,
          providerTypeId: null,
          ownerInfoSubmitted: false,
          companions: [],
          selectedCompanion: null,
          serviceProvider: { serviceProviderType: "" },
        }),
      serviceProvider: { serviceProviderType: "" },
      setServiceProvider: (data) => {
        set((state) => ({ serviceProvider: { ...state.serviceProvider, ...data } }));
      },
      clearServiceProviderId: () => set({ serviceProviderId: null }),
    }),
    {
      name: "service-provider-onboarding-store",
      partialize: (state) => ({
        serviceProviderId: state.serviceProviderId,
        providerTypeId: state.providerTypeId,
        ownerInfoSubmitted: state.ownerInfoSubmitted,
        companions: state.companions,
        selectedCompanion: state.selectedCompanion,
        serviceProvider: state.serviceProvider,
      }),
    },
  ),
);
